import { SubTitle, MarkText } from './Details.styles';

interface TextInterface {
  title: string;
  value: string | number;
}

export default function Text({ title, value }: TextInterface) {

  return (
    <SubTitle>
      {title} <MarkText>{value}</MarkText>
    </SubTitle>
  );
}
